import React from "react";
import "./CardVote.scss";
import { useQuestionStore } from "../stores/QuestionStore";
import { observer } from "mobx-react-lite";

export const CardVote = observer(() => {
  const questionStore = useQuestionStore();

  const getOneQuestion =
    questionStore.questions[questionStore.countQuestion] && questionStore.questions[questionStore.countQuestion].text;

  const clickLike = () => {
    var element = document.getElementById("card");
    element.classList.add("animation-right");
    setTimeout(() => {
      questionStore.onClickUpdateLikes();
    }, 750);
    setTimeout(() => {
      element.classList.remove("animation-right");
    }, 1000);
  };

  const clickDislike = () => {
    var element = document.getElementById("card");
    element.classList.add("animation-left");
    setTimeout(() => {
      questionStore.onClickUpdateDislikes();
    }, 750);
    setTimeout(() => {
      element.classList.remove("animation-left");
    }, 1000);
  };

  return (
    <div className="CardVote">
      <div className="card-container-background">
        <div className="card" id="card">
          <div className="card-container">
            <header className="card-header">
              <p className="header-title">DEEP QUEST</p>
            </header>
            <div className="card-content">
              <div className="content">{getOneQuestion}</div>
            </div>
            <footer className="card-footer">
              <p>Get to know each other.</p>
            </footer>
          </div>
        </div>
      </div>
      <div className="buttons">
        <button className="button is-danger" onClick={clickDislike}>
          Nope
        </button>
        <button className="button is-success" onClick={clickLike}>
          Deep
        </button>
      </div>
    </div>
  );
});
